<template>
  <div id="selfdeil">
    <h3>设备评价详情</h3>
    <div class="infoDeil">
      <div class="item" @click="rowClick(key, value)" :class="{ margin15: index == 2 || index == 7 || index == 11 }" v-for="(value, key, index) in info" :key="`${key}a`">
        <span class="row2">{{ key }}：</span>
        <span v-if="key != '评审流程状态' && key != '评审类型' && key != '自评结果' && key != '评审证书'">{{ value }}</span>
        <span v-if="key == '评审流程状态'" :class="['orange', 'orange', 'theme', 'red', 'green'][value - 1]">
          {{ ['企业待自评', '专家待分配', '专家评审中', '已截止', '已完成'][value - 1] }}
        </span>
        <span v-if="key == '评审类型'">
          {{ ['日常评审', '年度评审'][value - 1] }}
        </span>
        <span style="cursor: pointer" v-if="key == '自评结果' || key == '评审证书'" class="blue">
          {{ value }}
        </span>
        <div></div>
      </div>
    </div>
    <div class="btnGurop">
      <el-button @click="common.returnBtn"><i class="el-icon-arrow-left"></i></el-button>
      <el-button type="primary" @click="rowClick('查看自评报告', '')">查看自评报告</el-button>
      <el-button type="primary" @click="rowClick('查看评审报告', '')">查看评审报告</el-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'selfdeil',
  components: {},
  data() {
    return {
      bankId: this.$route.query.id, // 流程 id
      selfId: this.$route.query.selfId, // 自评 id
      info: {},
      inFoINmes: {},
    };
  },
  watch: {},
  created() {
    this.getExaminationInfo();
    this.info.用户名称 = this.currentUser?.enterprieName;
    this.info.目前所涉及的行业 = this.currentUser?.category;
  },
  mounted() {},
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    moment,
    // 获取详情回显内容
    getExaminationInfo() {
      this.$axios.post('api/selfAssessment/info', { id: this.bankId }).then((res) => {
        if (res.data.code == 200) {
          const data = res.data.data;
          this.inFoINmes = data;
          this.info = {
            用户名称: this.currentUser?.enterprieName,
            目前所涉及的行业: this.currentUser?.category,
            自评时间: data.selfAssessmentTime ? moment(data.selfAssessmentTime).format('YYYY-MM-DD') : '--',
            评审流程状态: data.status,
            评审类型: data.type,
            分配时间: data.expertTime ? moment(data.expertTime).format('YYYY-MM-DD') : '--',
            评审专家: data.expertName || '--',
            评审完成时间: data.expertReviewTime ? moment(data.expertReviewTime).format('YYYY-MM-DD') : '--',
            自评结果: '查看自评结果',
            评价依据: data.paperName || '--',
            自评得分: data.selfScore || '--',
            专家评审得分: data.appraisalResult || '--',
            设备管理成熟度: data.evaluate ? `${data.evaluate}%` : '--',
            星级: data.starLevel || '--',
            整改意见: '--',
          };
          if (data.status == 5) {
            this.$set(this.info, '评审证书', '查看评审证书');
          }
        }
      });
    },
    rowClick(key, value) {
      switch (key) {
        case '自评结果':
          this.$router.push({
            path: '/initiaSelf',
            query: { id: this.bankId, selfId: this.selfId, isEdit: true },
          });
          break;
        case '评审证书':
          this.$message({
            message: `正在开发中～`,
            type: 'success',
            offset: 80,
          });
          break;
        case '查看评审报告':
          if (this.info.评审流程状态 == 5) {
            if (this.inFoINmes.expertUsableNumber > 0 || this.inFoINmes.expertUsableNumber == null) {
              window.open(`${this.report}/report.html?selfId=${this.selfId}`, '_blank');
              this.common.reportsNumber(2);
            } else {
              this.$message({
                message: `使用次数不足，请联系管理员！`,
                type: 'error',
                offset: 80,
              });
            }
          } else {
            this.$message({
              message: `正在评审中！`,
              type: 'error',
              offset: 80,
            });
          }

          break;
        case '查看自评报告':
          if (this.inFoINmes.selfUsableNumber > 0 || this.inFoINmes.selfUsableNumber == null) {
            window.open(`${this.report}/reportSeif.html?selfId=${this.selfId}`, '_blank');
            this.common.reportsNumber(1);
          } else {
            this.$message({
              message: `使用次数不足，请联系管理员！`,
              type: 'error',
              offset: 80,
            });
          }

          break;

        default:
          break;
      }
      this.getExaminationInfo();
    },
  },
};
</script>

<style lang="less" scoped>
.infoDeil {
  margin: 15px;
  margin-bottom: 60px;
  .item {
    color: rgb(80, 88, 105);
    display: flex;
    line-height: 32px;
    .row2 {
      min-width: 140px;
    }
    &:last-child {
      flex: 1;
    }
  }
}
.margin15 {
  margin-bottom: 25px;
}
.btnGurop {
  position: fixed;
  bottom: 0;
  display: flex;
  background-color: #fff;
  height: 50px;
  align-items: center;
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
}
</style>
